import styled from 'styled-components';

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
`;

export const Navlinks = styled.ul`
  padding: 0 8px;
  list-style: none;
  display: flex;
  justify-content: space-between;
  position: relative;
  align-items: center;

  li {
    display: inline-block;
    padding: 16px 24px;

    a {
      font-weight: 700;
      text-decoration: none;
      color: black;
    }
  }

  &:hover {
    color: red;
  }
`;

export const Logo = styled.div`
    width: 200px;
    padding: 16px 0;
    margin: 0 auto;
`;
